/**
 * LOP Bar Promo - Carrusel de mensajes promocionales
 * Inicializa todos los bar promo en la página (por section id).
 */
(function() {
  function initBarPromo(wrapper) {
    if (!wrapper) return;
    var carousel = wrapper.querySelector('.lop-bar-promo-carousel');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.lop-bar-promo-slide');
    if (slides.length <= 1) return;

    var currentIndex = 0;
    var totalSlides = slides.length;
    var prevButton = wrapper.querySelector('.lop-bar-promo-arrow-prev');
    var nextButton = wrapper.querySelector('.lop-bar-promo-arrow-next');
    var autoplay = wrapper.dataset.autoplay === 'true';
    var autoplayInterval = parseInt(wrapper.dataset.autoplayInterval, 10) || 5000;
    var autoplayTimer = null;

    function updateCarousel() {
      slides.forEach(function(slide, index) {
        if (index === currentIndex) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });
    }

    function goToSlide(index) {
      if (index < 0) {
        currentIndex = totalSlides - 1;
      } else if (index >= totalSlides) {
        currentIndex = 0;
      } else {
        currentIndex = index;
      }
      updateCarousel();
      if (autoplay && autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = setInterval(nextSlide, autoplayInterval);
      }
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    if (prevButton) {
      prevButton.addEventListener('click', prevSlide);
    }
    if (nextButton) {
      nextButton.addEventListener('click', nextSlide);
    }

    if (autoplay) {
      autoplayTimer = setInterval(nextSlide, autoplayInterval);
    }

    updateCarousel();
  }

  function initAll() {
    var wrappers = document.querySelectorAll('.lop-bar-promo[data-section-id]');
    wrappers.forEach(function(wrapper) {
      initBarPromo(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(evt) {
    var section = evt.target;
    var wrapper = section.querySelector('.lop-bar-promo');
    if (wrapper) {
      initBarPromo(wrapper);
    }
  });
})();
